const list = [
  { name: 'ReactJs', iconClassName: 'fab fa-react fa-fw', color: 'text-react' },
  { name: 'HTML5', iconClassName: 'fab fa-html5 fa-fw', color: 'text-html5' },
  { name: 'CSS3', iconClassName: 'fab fa-css3 fa-fw', color: 'text-css3' },
  {
    name: 'Wordpress',
    iconClassName: 'fab fa-wordpress fa-fw',
    color: 'text-'
  },
  {
    name: 'Javascript',
    iconClassName: 'fab fa-js-square fa-fw',
    color: 'text-js'
  },
  {
    name: 'Bootstrap',
    iconClassName: 'fab fa-bootstrap fa-fw',
    color: 'text-bootstrap'
  },
  { name: 'GulpJs', iconClassName: 'fab fa-gulp fa-fw', color: 'text-gulp' },
  { name: 'Git', iconClassName: 'fab fa-git fa-fw', color: '' },
  { name: 'NodeJs', iconClassName: 'fab fa-node fa-fw', color: 'text-node' },
  { name: 'PHP', iconClassName: 'fab fa-php fa-fw', color: 'text-php' },
  { name: 'Sass', iconClassName: 'fab fa-sass fa-fw', color: 'text-sass' }
];

export { list };
